import React, { useEffect } from 'react';
import Typed from 'typed.js';

const HeroSection = () => {
  useEffect(() => {
    const typed = new Typed('.typing-text', {
      strings: [
        'Website development',
        'Staffing Solutions',
        'Quality Assurance',
        'Web Solutions',
        'Business Branding',
      ],
      loop: true,
      typeSpeed: 90,
      backSpeed: 30,
      backDelay: 600,
    });
    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <section 
    className="hero-section"
    style={{
    boxShadow: '0 10px 20px rgba(15, 55, 187, 0.9)' 
  }}
    >
      <div className="hero-text">
        <h2>
            Panorama Software Solutions Pvt Ltd
          <br /> Taking you <span style={{ color: '#FFD700' }}>forward...</span>
        </h2>
        <p>We expertise in <span className="typing-text"></span></p>
      </div>
    </section>
  );
};

export default HeroSection;
